import React, { useEffect, useState } from "react";
import { Breadcrumb, TreeviewDropdown, ModalPopup } from "../../CommonComponent";
import CommonControl from "../../CommonControl";
import { useTranslation } from "react-i18next";
import { selectors as globalDataSelector, operations as commondataoperations } from "../../../state/features/common/globaldata";
import { useDispatch, useSelector } from "react-redux";
import './cartbreadcrumbs.scss';
import { RESOURCE } from "../../../const/resource";
import partsService from "../../../services/partsservice";
import { selectors as headerSelector } from "../../../state/features/header";
import { Iprops } from "../BreadCrumbs/breadcrumbsinterface";
import DistributorService from "../../../services/distributorservice";
import { confirmAlert } from "react-confirm-alert";
import { ICartContextType } from "../ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../shoppingcart";
import { useAppContext } from "../../App/App";
import { IAppContextProps } from "../../App/AppInterface";

const BreadCrumbs = (props: Iprops) => {
    const [branchValues, setBranchValues] = useState("");
    const [currentViewModal, setCurrentViewModal] = useState(false);
    const [isShopingCartUpdate, setIsShopingCartUpdate] = useState(false);
    const [updateButtonEnable, setIsUpdateButtonEnable] = useState(false);
    const [isUpdateClick, setIsUpdateClick] = useState(false);
    const [branchOption, setBranchOption] = useState<[]>([]);
    const dispatch = useDispatch();
    const dispatchsetGlobalData = commondataoperations.dispatchCurrentGlobalData(dispatch);
    const { t } = useTranslation();
    const { isGuestUser }: ICartContextType = useCartContext();
    const { setIsMixedFleetDistributor }: IAppContextProps = useAppContext();

    const { headercurrentuser }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));
    const userRoleType = headercurrentuser?.usertype?.name ? headercurrentuser?.usertype?.name?.toLowerCase() : "customer";
    const companyName = headercurrentuser?.companyName ?? '';

    const isMultiDistributorDD = (userRoleType == "company" || userRoleType == "employee" || headercurrentuser.isWideAreaUser || headercurrentuser.isMultiDistributor);
    const isCustomerDD = (userRoleType == "customer" && !headercurrentuser.isWideAreaUser && !headercurrentuser.isMultiDistributor);
    const getSelectionText = () => {
        if (isMultiDistributorDD) {
            return t(RESOURCE.MyK_Label_SC_Select_Distributor);
        }
        else if (isCustomerDD) {
            return t(RESOURCE.MyK_Label_SC_Select_Location);
        }
        else {
           return t(RESOURCE.MyK_Label_SC_Select_Customer);
        }
    }

    const selectionText = getSelectionText();
    useEffect(() => {
        if(globalData?.BranchCode) {
            setBranchValues(globalData?.BranchCode);
        }
    },[globalData?.BranchCode]);


    useEffect(() => {
        if (!isGuestUser)
        setSessionData();
    }, [globalData]);

    const setSessionData = () => {
        if (
            globalData != undefined &&
            Object.keys(globalData).length != 0 &&
            headercurrentuser?.azureADId != undefined &&
            headercurrentuser?.azureADId != null
        ) {
            let globalDataUpdate = Object.assign({}, globalData);
            DistributorService.setSessionData(headercurrentuser?.azureADId, globalDataUpdate)
                .then(async (response: any) => { })
                .catch((e: any) => { });
        }
    };

    const checkIsNullOrEmpty = (data :any) => {
        return ((data ?? "") != "");
    }

    const isGlobalDataSelected = checkIsNullOrEmpty(globalData?.CustomerId) && checkIsNullOrEmpty(globalData?.LocationId) && checkIsNullOrEmpty(globalData?.DistributorCode);
    const messageTemplate = () => {
        return (
            <div className='messageTemplatebody messageAlign'>
                <b className="messageinfo">
                    {t(RESOURCE.MyK_Label_SC_Branch_Change_Confirm)}
                </b>
                <p>{t(RESOURCE.MyK_Label_SC_Branch_Change_ConfirmInfo)}</p>
            </div>
        );
    };

    const checkFunctionAndCall = (callback : any, value:any = null) => {
        if (typeof callback === 'function') {
            if (value) {
                callback(value);
            }
            else {
                callback();
            }
        }
    }

    const branchHandleOnChange = (value: any, title: any) => {
        if (props?.isCheckoutPage) {
            confirmAlert({
                title: t(RESOURCE.MyK_Label_Confirm_Title),
                overlayClassName: "overlay-custom-class-name",
                closeOnEscape: false,
                message: messageTemplate() as any,
                buttons: [
                    {
                        label: t(RESOURCE.MyK_Label_Cancel),
                        title: t(RESOURCE.MyK_Label_Cancel),
                        onClick: () => { }
                    },
                    {
                        label: t(RESOURCE.MyK_Label_SC_Confirm),
                        title: t(RESOURCE.MyK_Label_SC_Confirm),
                        className: "btnYellow",
                        onClick: () => {
                            dispatchsetGlobalData({
                                BranchName: title?.length > 0 ? title[0] : title,
                                BranchCode: value,
                            });
                            checkFunctionAndCall(props?.getMachineManufacturePunchoutButton,value);
                            if (props?.shoppingcartOnClick) {
                                props.shoppingcartOnClick();
                            }
                        },
                    },
                ],
                closeOnClickOutside: false,
                keyCodeForClose: [8, 32],
            });
        }
        else {
            dispatchsetGlobalData({
                BranchName: title?.length > 0 ? title[0] : title,
                BranchCode: value,
            });
            checkFunctionAndCall(props?.getMachineManufacturePunchoutButton, value);
        }
    }

    const hidePopup = () => {
        setCurrentViewModal(false);
    }

    useEffect(() => {
        if (props?.isPriceAndAvailabilityRequired) {
            CurrentlyViewingOnClick();
            props?.setIsPriceAndAvailabilityRequired(false);
        }
    }, [props?.isPriceAndAvailabilityRequired])

    const onUpdate = () => {
        setIsUpdateClick(true);
        if (updateButtonEnable) {
            setIsShopingCartUpdate(true);
            setIsMixedFleetDistributor(null)
        }
    }

    const CurrentlyViewingOnClick = () => {
        setCurrentViewModal(true)
        setIsUpdateClick(false);
    }

    const isItemsEmpty = (items: any[]) => {
        return !items || items.length <= 0;
    };

    const getSelectedItemForBranch = (response: any, selectedBranch: any, selectedBranchName:any) => {
        return (response?.find((s: any) => (s.id == String(selectedBranch) && (selectedBranchName?.trim()?.length <= 0 || (selectedBranchName?.length > 0 && s.name == String(selectedBranchName))))))
    }

    const getValueOrEmpty = (value: any) => {
        return value ?? "";
    }

    useEffect(() => {
        if (isGlobalDataSelected) {
            setBranchOption([]);
            const selectedBranch = getValueOrEmpty(globalData?.BranchCode);
            const selectedBranchName = getValueOrEmpty(globalData?.BranchName);
            dispatchsetGlobalData({
                BranchName: "",
                BranchCode: "",
            });
            setBranchValues("");
            partsService.getBranchList(globalData.DistributorCode, globalData.CustomerId, globalData.LocationId)
                .then((response: any) => {
                    if (response?.length == 0) {
                        props?.setCartDetails({});
                    }
                    const option = response?.map((t: any) => ({ title: t.name, value: t.id })) ?? [];
                    setBranchOption(option);
                    let seletedItems = getSelectedItemForBranch(response, selectedBranch, selectedBranchName);
                    if (isItemsEmpty(seletedItems)) {
                        seletedItems = response?.find((s: any) => (s.selected));
                    }
                    let value = seletedItems?.id ?? "";
                    let name = seletedItems?.name;
                    if (value == "" && option?.length > 0) {
                        value = option[0]?.value;
                        name = option[0]?.title;
                    }
                    setBranchValues(value);
                    checkFunctionAndCall(props?.getMachineManufacturePunchoutButton, value);
                    dispatchsetGlobalData({
                        BranchName: name,
                        BranchCode: value,
                    });
                })
                .catch((e: any) => {
                    props?.setCartDetails({});
                    checkFunctionAndCall(props?.clearMachineManufacturePunchoutButton);
                    dispatchsetGlobalData({
                        BranchName: "",
                        BranchCode: "",
                    });
                });
        }
        else {
            setBranchOption([]);
            setCurrentViewModal(true);
        }
    }, [globalData?.CustomerId, globalData?.LocationId, globalData?.DistributorCode])

    const getDistributorName = () => {
        const distributorDisplayName = isGuestUser ? `${globalData.DistributorName} (${globalData.DistributorCode}-${globalData.BranchCode})` : globalData?.DistributorName;
        return (((globalData.DistributorName ?? "") == "") ? companyName : distributorDisplayName);
    }

    return (
        <div className="shoppingcart_breadcrump-Wrapper row px-4">
            <div className="col-12 col-md-7 Breadcrumbhegith">
                <Breadcrumb items={props.breadcrumItems} />
            </div>
            <div className="col-12 col-md-5">
                <div className="shoppingcart_Current-View">
                    <div className='CurrentlyviewingWrapper'>
                        {isGlobalDataSelected ?
                            <>{ !isGuestUser && <span className="current_view" title={t(RESOURCE.MyK_Label_ShoppingCart_Currently_Viewing)} onClick={CurrentlyViewingOnClick} onKeyDown={() => { }}>{t(RESOURCE.MyK_Label_ShoppingCart_Currently_Viewing)}:</span>}
                                <span title={getDistributorName()} className={`current_view-text ml-1 ${isGuestUser ? 'fullText' : ''}`}>{getDistributorName()}</span>
                            </> :
                            !isGuestUser && <span className="current_view" title={t(RESOURCE.Myk_Label_Select_Location)} onClick={CurrentlyViewingOnClick} onKeyDown={() => { }}>{t(RESOURCE.Myk_Label_Select_Location)}</span>
                        }
                        {isGuestUser && <span title={getDistributorName()} className={`current_view-text ml-1 ${isGuestUser ? 'fullText' : ''}`}>{getDistributorName()}</span>}
                    </div>
                    {!isGuestUser && <div className='branchWrapper'>
                        <span className="branch mr-1">{t(RESOURCE.Myk_Label_Branch)} </span>
                        <TreeviewDropdown
                            treeData={branchOption}
                            showSearch={true}
                            className='SelectOrderingBranch'
                            dropdownClassName={'dropdownListContainer noNested'}
                            placeholder={t(RESOURCE.MyK_Label_ShoppingCart_Select_Branch)}
                            value={branchValues}
                            onChange={(value: any, title: any) => { branchHandleOnChange(value, title) }}
                        />
                    </div>}
                </div>
            </div>


            {(!isGuestUser && currentViewModal) ? (
                <div className="addSaveListPopup shoppingCart availabilityPopup">
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle=''
                        ModalPopupType="large"
                        closeModalPopup={hidePopup}
                        PrimaryBtnOnclick={onUpdate}
                        FooterPrimaryBtnTxt={t(RESOURCE.MyK_Label_ShoppingCart_Update)}
                        ModalPopupName={'cartbreadcrumbs'}
                    >
                        <div className='shoppingCommoncontoleHD'>{selectionText}</div>
                        <CommonControl
                            isShopingCartUpdate={isShopingCartUpdate}
                            setIsUpdateButtonEnable={setIsUpdateButtonEnable}
                            setIsShopingCartUpdate={setIsShopingCartUpdate}
                            isFromShoppingCart={true}
                            isCheckoutPage={props.isCheckoutPage}
                            setCurrentViewModal={setCurrentViewModal}
                            isUpdateClick={isUpdateClick}
                            shoppingcartOnClick={props.shoppingcartOnClick}
                        />
                    </ModalPopup>
                </div>
            ) : null}


        </div>
    )
}

export default BreadCrumbs;